import React from 'react';
import { OfferRequisition } from '../../../../../../entities/v1/applicant_tracking/OfferRequisition';
import { User } from '../../../../../../entities/User';
import { OwnerOrAdminActions } from './OwnerOrAdminActions';
import { AlertMessage } from '../../../../../../components/AlertMessage';
import { AlertObject } from '../../../../../../components/Alert';

interface PropTypes {
  currentUser: User;
  offerRequisition: OfferRequisition;
  onEditOfferRequisition: () => void;
  setAlertMessage: (message: AlertObject) => void;
  reloadOfferRequisition: () => void;
}

export function DeclinedAction(props: PropTypes) {
  const isOwnerOrAdmin =
    props.offerRequisition.ownerUserId === props.currentUser.id ||
    props.currentUser.isAdmin;

  return (
    <div className='d-flex align-items-center'>
      {isOwnerOrAdmin ? (
        <OwnerOrAdminActions
          currentUser={props.currentUser}
          offerRequisition={props.offerRequisition}
          onEditOfferRequisition={props.onEditOfferRequisition}
          setAlertMessage={props.setAlertMessage}
          reloadOfferRequisition={props.reloadOfferRequisition}
        />
      ) : (
        <AlertMessage
          className='bg-light-danger fs-5'
          icon={{ name: 'bi-info-circle' }}
          text='This offer requisition has been declined.'
        />
      )}
    </div>
  );
}
